
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gwoQm", function(module, exports) {

$parcel$export(module.exports, "loadingSpinner", () => $c072e7e9da7baaac$export$deaa9e6d912ce6c6);
$parcel$export(module.exports, "errorPopup", () => $c072e7e9da7baaac$export$ec267e3635bd0be4);
$parcel$export(module.exports, "successPopup", () => $c072e7e9da7baaac$export$89dc853842deb0b3);
$parcel$export(module.exports, "formatTimestamp", () => $c072e7e9da7baaac$export$bfe4ac50319c1d9b);
$parcel$export(module.exports, "refreshTooltips", () => $c072e7e9da7baaac$export$a2bc61e91eae259f);
$parcel$export(module.exports, "auditLink", () => $c072e7e9da7baaac$export$b49df0c9c7ae6e6d);

var $dwTAg = parcelRequire("dwTAg");
const $c072e7e9da7baaac$export$deaa9e6d912ce6c6 = `
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <span class="sr-only">Loading...</span>
`;
function $c072e7e9da7baaac$export$ec267e3635bd0be4(error) {
    console.error(error);
    $('#error-toast-body').text(error);
    new bootstrap.Toast($('#error-toast')).show();
}
function $c072e7e9da7baaac$export$89dc853842deb0b3(message) {
    console.info(`Success: ${message}`);
    $('#success-toast-body').text(message);
    new bootstrap.Toast($('#success-toast')).show();
}
function $c072e7e9da7baaac$export$bfe4ac50319c1d9b(timestamp) {
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString("en-US", {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).replace(' at ', '<br />');
}
function $c072e7e9da7baaac$export$72439bf08da4c934(e) {
    const addressControl = e.currentTarget;
    navigator.clipboard.writeText(addressControl.dataset.bsOriginalTitle);
    addressControl.style.transition = '';
    addressControl.style.setProperty('color', 'green', 'important');
    addressControl.style.opacity = '0.75';
    setTimeout(function() {
        addressControl.style.transition = 'color 1s, opacity 1s';
        addressControl.style.removeProperty('color');
        addressControl.style.opacity = '1';
    }, 50);
    setTimeout(function() {
        addressControl.style.transition = '';
    }, 600);
}
function $c072e7e9da7baaac$export$a2bc61e91eae259f() {
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-bs-toggle="tooltip"]').tooltip();
    $('.pretty-address').click($c072e7e9da7baaac$export$72439bf08da4c934);
}
function $c072e7e9da7baaac$export$b49df0c9c7ae6e6d(chainID, verificationReferenceID) {
    return `<a href="#" onClick="AuditRequest=window.open('${window.location.origin}/audit/?chain-id=${chainID}&verification-reference-id=${verificationReferenceID}','AuditRequest','width=450,height=560'); return false;">${(0, $dwTAg.prettyAddress)(verificationReferenceID, false)}</a>`;
}
var $c072e7e9da7baaac$export$2e2bcd8739ae039 = {
    loadingSpinner: $c072e7e9da7baaac$export$deaa9e6d912ce6c6,
    errorPopup: $c072e7e9da7baaac$export$ec267e3635bd0be4,
    successPopup: $c072e7e9da7baaac$export$89dc853842deb0b3,
    formatTimestamp: $c072e7e9da7baaac$export$bfe4ac50319c1d9b,
    copyAddress: $c072e7e9da7baaac$export$72439bf08da4c934,
    refreshTooltips: $c072e7e9da7baaac$export$a2bc61e91eae259f,
    auditLink: $c072e7e9da7baaac$export$b49df0c9c7ae6e6d
};

});
parcelRegister("dwTAg", function(module, exports) {

$parcel$export(module.exports, "prettyAddress", () => $9d996150ec4a9bef$export$f80bcf15052a775);
function $9d996150ec4a9bef$export$f80bcf15052a775(address, copy = true) {
    if (address === undefined || address.length != 42 && address.length != 66) return address;
    const shortAddress = `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
    return copy ? `<span class="pretty-address" data-toggle="tooltip" data-placement="top" title="${address}">${shortAddress} <i class="fa-solid fa-copy"></i></span>` : shortAddress;
}
var $9d996150ec4a9bef$export$2e2bcd8739ae039 = {
    prettyAddress: $9d996150ec4a9bef$export$f80bcf15052a775
};

});



var $gwoQm = parcelRequire("gwoQm");

var $dwTAg = parcelRequire("dwTAg");

var $3cMgf = parcelRequire("3cMgf");
const $b1b8200ca9457e93$export$441b8e204bd6f9d4 = [
    {
        "inputs": [],
        "name": "compliance",
        "outputs": [
            {
                "internalType": "contract ICompliance",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
];
var $b1b8200ca9457e93$export$2e2bcd8739ae039 = $b1b8200ca9457e93$export$441b8e204bd6f9d4;


const $2bea916d2502c37c$export$740019d0dc02f0ca = [
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "dapp",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "bytes32",
                "name": "fullHash",
                "type": "bytes32"
            },
            {
                "indexed": true,
                "internalType": "bytes32",
                "name": "partialHash",
                "type": "bytes32"
            }
        ],
        "name": "ApprovalRequired",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "dapp",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "bytes32",
                "name": "fullHash",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "internalType": "string",
                "name": "complianceDetails",
                "type": "string"
            }
        ],
        "name": "ComplianceConsumed",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "dapp",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "bytes32",
                "name": "fullHash",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "internalType": "string",
                "name": "complianceDetails",
                "type": "string"
            }
        ],
        "name": "ComplianceRegistered",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "dapp",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "bytes32",
                "name": "fullHash",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "ComplianceVerdict",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "chainid",
                "type": "uint256"
            },
            {
                "internalType": "bytes4",
                "name": "functionSelector",
                "type": "bytes4"
            },
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "token",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "value",
                "type": "uint256"
            }
        ],
        "name": "computeErc20TransferPartialHash",
        "outputs": [
            {
                "internalType": "bytes32",
                "name": "partialHash",
                "type": "bytes32"
            }
        ],
        "stateMutability": "pure",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "chainid",
                "type": "uint256"
            },
            {
                "internalType": "bytes4",
                "name": "functionSelector",
                "type": "bytes4"
            },
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "token",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "value",
                "type": "uint256"
            },
            {
                "internalType": "bytes",
                "name": "data",
                "type": "bytes"
            }
        ],
        "name": "computeErc20TransferWithDataPartialHash",
        "outputs": [
            {
                "internalType": "bytes32",
                "name": "partialHash",
                "type": "bytes32"
            }
        ],
        "stateMutability": "pure",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "chainid",
                "type": "uint256"
            },
            {
                "internalType": "bytes4",
                "name": "functionSelector",
                "type": "bytes4"
            },
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "value",
                "type": "uint256"
            }
        ],
        "name": "computeEthTransferPartialHash",
        "outputs": [
            {
                "internalType": "bytes32",
                "name": "partialHash",
                "type": "bytes32"
            }
        ],
        "stateMutability": "pure",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "chainid",
                "type": "uint256"
            },
            {
                "internalType": "bytes4",
                "name": "functionSelector",
                "type": "bytes4"
            },
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "value",
                "type": "uint256"
            },
            {
                "internalType": "bytes",
                "name": "data",
                "type": "bytes"
            }
        ],
        "name": "computeEthTransferWithDataPartialHash",
        "outputs": [
            {
                "internalType": "bytes32",
                "name": "partialHash",
                "type": "bytes32"
            }
        ],
        "stateMutability": "pure",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "chainid",
                "type": "uint256"
            },
            {
                "internalType": "bytes4",
                "name": "functionSelector",
                "type": "bytes4"
            },
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "value",
                "type": "uint256"
            },
            {
                "internalType": "bytes",
                "name": "data",
                "type": "bytes"
            }
        ],
        "name": "computeGenericCallPartialHash",
        "outputs": [
            {
                "internalType": "bytes32",
                "name": "partialHash",
                "type": "bytes32"
            }
        ],
        "stateMutability": "pure",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "dapp",
                "type": "address"
            },
            {
                "internalType": "bytes32",
                "name": "partialHash",
                "type": "bytes32"
            }
        ],
        "name": "getStatus",
        "outputs": [
            {
                "internalType": "enum IComplianceOracle.Status",
                "name": "",
                "type": "uint8"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "dapp",
                "type": "address"
            },
            {
                "internalType": "bytes32",
                "name": "partialHash",
                "type": "bytes32"
            },
            {
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "issueVerdict",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }
];
var $2bea916d2502c37c$export$2e2bcd8739ae039 = $2bea916d2502c37c$export$740019d0dc02f0ca;



var $1dRRv = parcelRequire("1dRRv");
async function $2c866210faad9c37$var$fetchPendingUsersApproval() {
    const signer = await (0, $3cMgf.getSigner)();
    const chainId = (await signer.provider.getNetwork()).chainId;
    const dappId = $('#dapp-address-input').val();
    $('#fetch-pending-users-approval').html((0, $gwoQm.loadingSpinner));
    $('#pending-users-approval-table').hide();
    try {
        const pendingUsers = await getPendingUsersApproval(chainId, dappId);
        (0, $gwoQm.successPopup)('Pending users fetched successfully');
        $('#pending-users-approval-list').empty();
        $('#pending-users-approval-table').show();
        for (const [user, status] of Object.entries(pendingUsers)){
            const statusCell = status != 'pending' ? status : `
                <span id="verdict-${user}">
                    <button
                        type="button"
                        class="btn btn-primary"
                        id="verdict-button-${user}-approve"
                        onclick="setUserApproval('${chainId}', '${dappId}', '${user}', 'approved')">
                        Approve
                    </button>
                    &nbsp;
                    <button
                        type="button"
                        class="btn btn-danger"
                        id="verdict-button-${user}-reject"
                        onclick="setUserApproval('${chainId}', '${dappId}', '${user}', 'rejected')">
                        Reject
                    </button>
                </span>`;
            $('#pending-users-approval-list').append(`<tr>
                    <td>${user}</td>
                    <td>${statusCell}</td>
                </tr>`);
        }
    } catch (error) {
        (0, $gwoQm.errorPopup)(error);
    }
    $('#fetch-pending-users-approval').text('Fetch users');
}
async function $2c866210faad9c37$var$buildApprovalsTable() {
    const signer = await (0, $3cMgf.getSigner)();
    const chainId = (await signer.provider.getNetwork()).chainId;
    const dappAddress = $('#dapp-address-input').val();
    const dapp = new $1dRRv.Contract(dappAddress, (0, $b1b8200ca9457e93$export$2e2bcd8739ae039), signer);
    const complianceAddress = await dapp.compliance();
    const compliance = new $1dRRv.Contract(complianceAddress, (0, $2bea916d2502c37c$export$2e2bcd8739ae039), signer);
    const approvalsPromise = compliance.queryFilter(compliance.filters.ApprovalRequired(dappAddress));
    const approvals = (await approvalsPromise).reverse();
    if (approvals.length == 0) {
        $('#approvals').hide();
        return;
    }
    for(var i = 0; i < approvals.length; i++){
        const approval = approvals[i];
        const { fullHash: fullHash } = approval.args;
        approval.complianceConsumedPromise = compliance.queryFilter(compliance.filters.ComplianceConsumed(dappAddress, fullHash));
        approval.complianceConsumed = (await approval.complianceConsumedPromise).length > 0;
        if (approval.complianceConsumed) continue;
        approval.complianceDetailsPromise = compliance.queryFilter(compliance.filters.ComplianceRegistered(dappAddress, fullHash));
        approval.complianceVerdictPromise = compliance.queryFilter(compliance.filters.ComplianceVerdict(dappAddress, fullHash));
        approval.blockPromise = signer.provider.getBlock(approval.blockNumber);
    }
    for(var i = 0; i < approvals.length; i++){
        const approval = approvals[i];
        if (approval.complianceConsumed) continue;
        approval.complianceVerdict = await approval.complianceVerdictPromise;
        approval.verdictBlockPromise = approval.complianceVerdict.length == 0 ? null : signer.provider.getBlock(approval.complianceVerdict[0].blockNumber);
    }
    for(var i = 0; i < approvals.length; i++){
        const approval = approvals[i];
        if (approval.complianceConsumed) continue;
        approval.complianceDetails = (await approval.complianceDetailsPromise)[0].args.complianceDetails;
        approval.timestamp = (await approval.blockPromise).timestamp;
        approval.verdictTimestamp = approval.verdictBlockPromise === null ? null : (await approval.verdictBlockPromise).timestamp;
    }
    $('#approvals-table').empty();
    for(var i = 0; i < approvals.length; i++){
        const approval = approvals[i];
        if (approval.complianceConsumed) continue;
        console.log("approval", approval);
        const { fullHash: fullHash, partialHash: partialHash } = approval.args;
        var richArgs = `All: ${fullHash}<br />`;
        for(var j = 0; j < approval.complianceDetails.length; j++){
            const comSubData = approval.complianceDetails[j];
            richArgs += `${comSubData.complianceType} [${comSubData.providerName}]${comSubData.ref ? ': ' : ''}${(0, $gwoQm.auditLink)(chainId, comSubData.ref)}<br />`;
        }
        approval.state = approval.complianceVerdict.length > 0 ? `${approval.complianceVerdict[0].args.approved ? 'Approved' : 'Rejected'} on ${(0, $gwoQm.formatTimestamp)(Number(approval.verdictTimestamp))}` : `
                <span id="verdict-${partialHash}">
                    <button
                        type="button"
                        class="btn btn-primary"
                        id="verdict-button-${partialHash}-approve">
                        Approve
                    </button>
                    &nbsp;
                    <button
                        type="button"
                        class="btn btn-danger"
                        id="verdict-button-${partialHash}-reject">
                        Reject
                    </button>
                </span>
            `;
        $('#approvals-table').append(`<tr>
            <td>${(0, $gwoQm.formatTimestamp)(Number(approval.timestamp))}</td>
            <td>${richArgs}</td>
            <td>${approval.state}</td>
        </tr>`);
        $(`#verdict-button-${partialHash}-approve`).on('click', function() {
            $2c866210faad9c37$var$issueVerdict(partialHash, true);
        });
        $(`#verdict-button-${partialHash}-reject`).on('click', function() {
            $2c866210faad9c37$var$issueVerdict(partialHash, false);
        });
    }
}
async function $2c866210faad9c37$var$connectDapp(autoConnect = false) {
    const dappAddress = $('#dapp-address-input').val();
    const prettyDappAddress = (0, $dwTAg.prettyAddress)(dappAddress);
    if (prettyDappAddress === dappAddress) {
        (0, $gwoQm.errorPopup)('Invalid Dapp address');
        return;
    }
    const signer = await (0, $3cMgf.getSigner)();
    const signerAddress = await signer.getAddress();
    const dapp = new $1dRRv.Contract(dappAddress, (0, $b1b8200ca9457e93$export$2e2bcd8739ae039), signer);
    const complianceAddress = await dapp.compliance();
    const compliance = new $1dRRv.Contract(complianceAddress, (0, $2bea916d2502c37c$export$2e2bcd8739ae039), signer);
    const controller_role = await compliance.CONTROLLER_ROLE();
    const signerIsController = await compliance.hasRole(controller_role, signerAddress);
    if (!signerIsController) {
        (0, $gwoQm.errorPopup)('You are not a registered controller of this Dapp');
        return;
    }
    $('#dapp-address').html(prettyDappAddress);
    (0, $gwoQm.refreshTooltips)();
    if (!autoConnect) (0, $gwoQm.successPopup)('Dapp connected successfully');
    $('#dapp-connected-false').hide();
    $('#dapp-connected-true').show();
    $('.require-dapp-connected-true').show();
    await $2c866210faad9c37$var$buildApprovalsTable();
}
async function $2c866210faad9c37$var$issueVerdict(partialHash, approved) {
    const dappAddress = $('#dapp-address-input').val();
    const clickedSelector = approved ? `#verdict-button-${partialHash}-approve` : `#verdict-button-${partialHash}-reject`;
    $(`#verdict-button-${partialHash}-approve`).prop('disabled', true);
    $(`#verdict-button-${partialHash}-reject`).prop('disabled', true);
    $(clickedSelector).html((0, $gwoQm.loadingSpinner));
    const signer = await (0, $3cMgf.getSigner)();
    const dapp = new $1dRRv.Contract(dappAddress, (0, $b1b8200ca9457e93$export$2e2bcd8739ae039), signer);
    const complianceAddress = await dapp.compliance();
    const compliance = new $1dRRv.Contract(complianceAddress, (0, $2bea916d2502c37c$export$2e2bcd8739ae039), signer);
    try {
        await compliance.issueVerdict(dappAddress, partialHash, approved);
    } catch (error) {
        (0, $gwoQm.errorPopup)(error.message);
        $(`#verdict-button-${partialHash}-approve`).prop('disabled', false);
        $(`#verdict-button-${partialHash}-reject`).prop('disabled', false);
        $(clickedSelector).html(approved ? 'Approve' : 'Reject');
        return;
    }
    $(`#verdict-${partialHash}`).html(`${approved ? 'Approved' : 'Rejected'} just now`);
}
(0, $3cMgf.onWalletConnect)(async ()=>{
    if ($('#dapp-address-input').val()) $2c866210faad9c37$var$connectDapp(true);
});
$(document).ready(function() {
    const searchParams = new URLSearchParams(window.location.search);
    (0, $3cMgf.providerInit)(searchParams.has('wallet') ? searchParams.get('wallet') : 'metamask');
    if (searchParams.has('dapp')) $('#dapp-address-input').val(searchParams.get('dapp'));
    $('#connect-dapp-form').on('submit', function(e) {
        e.preventDefault();
        $2c866210faad9c37$var$connectDapp();
    });
    $('#fetch-pending-users-approval-form').on('submit', function(e) {
        e.preventDefault();
        $2c866210faad9c37$var$fetchPendingUsersApproval();
    });
    if ((0, $3cMgf.isConnected) && $('#dapp-address-input').val()) $2c866210faad9c37$var$connectDapp(true);
});


//# sourceMappingURL=index.48fe8b2e.js.map
